import { render, staticRenderFns } from "./settingsTemplate.vue?vue&type=template&id=a4e43556&"
import script from "./settingsTemplate.vue?vue&type=script&lang=js&"
export * from "./settingsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports